export default __webpack_public_path__ + "static/tips-and-tricks-on-how-to-improve-your-mobile-ux-design-091c3c689435d418f147928351ea46e8.png";